<template>
  <div>
    <team-add></team-add>
  </div>
</template>

<script>
import TeamAdd from './TeamAdd.vue';

export default {
  components: {
    TeamAdd,
  },

  data() {
    return {};
  },
};
</script>
